import { buttonVariants } from '@/components/Button';
import Text from '@/components/Text';

const externalLinkProps = {
    target: '_blank',
    rel: 'noopener noreferrer'
};

const AgentKBLink = ({ linkText }: { linkText: string }) => {
    return (
        <Text.Body>
            <a
                className={buttonVariants({ variant: 'link' })}
                href='https://docs.squaredup.com/advanced-features/relay-agents'
                {...externalLinkProps}
            >
                {linkText}
            </a>
        </Text.Body>
    );
};

export default AgentKBLink;
